import { FC, useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { AxiosError } from 'axios'
import { Card } from 'components'
import { useLoading, useModal, usePersistForm, useToggle } from 'hooks'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import {
  ParamFaleConoscoResponseDto,
  TalkWithUsServices
} from 'services/NGT/Parameterization'
import TalkToUsService, {
  ITalkToUsResponseDto
} from 'services/NGT/TalkToUs'
import { SPACING, COLORS, OLDYUP as YUP } from 'utils'

import FilterTalkToUs from './components/FilterTalkToUs'
import TableTalkToUs from './components/TableTalkToUs'
import * as yup from 'yup'

interface ITalkToUsSearch {
  handleAnswerForm: (idFaleConosco: number) => void
}

export interface ITalkToUsProps {
  idMotivo: number
  idUsuario: number
  dtEnvioInicio: string
  dtEnvioFim: string
  nmUsuario: string
  txEmail: string
  flLiberado: boolean
}


const SCHEMA = yup.object({
  dtEnvioInicio: yup.date().nullable().notRequired().typeError('Digite uma data válida.'),
  dtEnvioFim: yup.date().nullable().min(yup.ref('dtEnvioInicio'), 'Data de envio fim deve ser maior que data envio inicio.').notRequired().typeError('Digite uma data válida.'),
  flLiberado: yup.boolean().nullable().notRequired(),
  idMotivo: yup.number().nullable().notRequired(),
  nmUsuario: yup.string().nullable().notRequired(),
  txEmail: yup.string().nullable().notRequired()
})


const TalkToUsSearch: FC<ITalkToUsSearch> = ({ handleAnswerForm }) => {
  const { showModal } = useModal()
  const { setLoading } = useLoading()

  const [parametrizationTalkToUs, setParametrizationTalkToUs] = useState<
    ParamFaleConoscoResponseDto[]
  >([])
  const [page, setPage] = useState<number>(1)
  const [pageCount, setPageCount] = useState<number>(1)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)
  const [changeEffect, toggleChangeEffect] = useToggle()

  const [talkToUsData, setTalkToUsData] = useState<ITalkToUsResponseDto[]>([])

  const {
    reset,
    watch,
    setValue,
    trigger,
    control,
    formState: { errors },
    handleSubmit
  } = useForm<ITalkToUsProps>({
    resolver: yupResolver(SCHEMA),
    defaultValues: {
      dtEnvioFim: null,
      dtEnvioInicio: null,
      idMotivo: 0,
      flLiberado: false
    }
  })

  usePersistForm('ngt_talk_to_us_search', {
    setValue,
    watch
  })

  const dtEnvioInicio = watch('dtEnvioInicio')
  const dtEnvioFim = watch('dtEnvioFim')


  // const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
  //   setSearchParams((oldData) => {
  //     return {
  //       ...oldData,
  //       [event.target.name]: event.target.value
  //     }
  //   })
  //   setValue(event.target.name, event.target.value)
  // }

  const areDatesValid = (): boolean => {
    if (
      (moment(dtEnvioInicio).isValid() &&
        !moment(dtEnvioFim).isValid()) ||
      (!moment(dtEnvioInicio).isValid() &&
        moment(dtEnvioFim).isValid())
    ) {
      return false
    }
    return (
      moment(dtEnvioInicio || moment()).isValid() &&
      moment(dtEnvioInicio || moment()).isValid() &&
      (dtEnvioFim && dtEnvioFim
        ? moment(dtEnvioInicio).isSameOrBefore(
          dtEnvioFim
        )
        : true)
    )
  }

  const handleOnClear = () => {
    // setSearchParams(() => DEFAULT_PARAMS_TALK_TO_US)
    reset()
    toggleChangeEffect()
    handleSearch(watch())
  }

  const handleSeachParametrizacao = () => {
    setLoading('loading')

    TalkWithUsServices()
      .getAllAutocomplete()
      .then(({ data }) => {
        if (data) {
          setParametrizationTalkToUs(data)
        }
      })
      .catch((error) => {
        const axiosError = error as AxiosError

        showModal({
          hideButtonCancel: true,
          message:
            axiosError.message ||
            'Não foi possivel obter as parametrizações de fale conosco',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const handleSearch = (form: ITalkToUsProps = {} as ITalkToUsProps) => {
    setLoading('loading')

    const formatData: ITalkToUsProps = {
      ...form,
      ...(form.idMotivo ? {
        idMotivo: form.idMotivo
      } : {
        idMotivo: 0
      }),
      ...(form.dtEnvioInicio && {
        dtEnvioInicio: moment(form.dtEnvioInicio).toISOString(),
      }),
      ...(form.dtEnvioFim && {
        dtEnvioFim: moment(form.dtEnvioFim).toISOString(),
      })
    }

    TalkToUsService()
      .getAllPaginated({
        ...formatData,
        pageNumber: page,
        pageSize: rowsPerPage
      })
      .then(({ data }) => {
        if (data) {
          setTalkToUsData(data.items)
          setPageCount(data.pageCount)
        }
      })
      .catch((error) => {
        const axisoError = error as AxiosError
        showModal({
          hideButtonCancel: true,
          message:
            axisoError.message ||
            'Não foi possivel obter as mensagens de fale conosco',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
      .finally(() => setLoading('idle'))
  }

  // useEffect(() => {
  //   const subs = watch(() => trigger())
  //   return () => subs.unsubscribe()
  // }, [watch])

  useEffect(() => {
    handleSeachParametrizacao()
  }, [])

  useEffect(() => {
    handleSearch(watch())
  }, [page, rowsPerPage])

  // useEffect(() => {
  //   handleOnSearchButton()
  // }, [changeEffect])

  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        padding={SPACING.spacing20}
        marginBottom={SPACING.spacing50}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <FilterTalkToUs
          control={control}
          handleOnSearch={handleSearch}
          // handleOnChange={handleOnChange}
          handleSubmit={handleSubmit}
          areDatesValid={areDatesValid}
          handleOnClear={handleOnClear}
          // searchParams={searchParams}
          parametrizationTalkToUs={parametrizationTalkToUs}
          errors={errors}
          watch={watch}
        />
        <TableTalkToUs
          tableData={talkToUsData}
          page={page}
          handleAnswerForm={handleAnswerForm}
          areDatesValid={areDatesValid}
          totalItems={pageCount}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        />
      </Card>
    </>
  )
}

export default TalkToUsSearch
